import { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";

import { API_URL_DONATE } from "../../utils/helpers";

import Msg from "../../components/Msg";

import PaymentCloverForm from "./PaymentCloverForm";

export default function PaymentClover({ cares, id, handleStatus }) {
	const [msg, setMsg] = useState({});

	const handleToken = async (token) => {
		console.log("Received Clover token:", token);

		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL_DONATE}/?f=ccPaymentClover`);
		const formData = new FormData();
		formData.append("id", id || "0");
		formData.append("token", token || "");
		formData.append("x", uuidv4());

		try {
			const response = await fetch(url.href, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({});
				handleStatus(json.id, 1);
			} else {
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div>
			<div className="msg-submit">
				{msg.type && <Msg data={msg} />}

				<div
					className={
						msg.type === "working" ? "hidden" : "clover-form-container"
					}
				>
					<PaymentCloverForm handleToken={handleToken} />
				</div>
			</div>
		</div>
	);
}
